











import { Component, Vue } from "vue-property-decorator";
import { deleteNews } from "@/services/news/newsService";

    @Component
export default class NewsDeleteModal extends Vue {
        // local state
        newsToDeleteId: string = "";

        // lifecycle hooks

        // computed

        // methods
        open(id: string) {
            this.newsToDeleteId = id;
            this.$bvModal.show("modal-deleteNews");
        }

        declineDelete() {
            this.newsToDeleteId = "";
            this.$bvModal.hide("modal-deleteNews");
        }

        confirmDelete() {
            this.$bvModal.hide("modal-deleteNews");
            deleteNews(this.newsToDeleteId).then(() => {
                this.$emit("reload");
            });
        }
}
